export var INITIAL_STATE = {
    loading: false,
    error: null,
    initialized: false,
    content: undefined,
    isOpenMenu: false,
    isPinned: false,
};
